/* eslint-disable react/display-name */
import * as React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { styled, css } from "@mui/system";
import { Modal as BaseModal } from "@mui/base/Modal";

import AccountVerification from "components/OtpInput/OtpInput";

import LoginModal from "./LoginModal";
import SignupModal from "./SignupModal";

export default function CustomModal({
  open,
  handleClose,
  setProgress,
  setSnackbarData,
  setOpenSnackbar,
  userEmail,
  cameFrom
}) {
  const [currentPage, setCurrentPage] = React.useState('');
  const [businessType, setBusinessType] = React.useState("Agency");
  const [email, setEmail]  = React.useState("");  

  React.useEffect(() => {
    if (userEmail) {
      setEmail(userEmail);
    } 
    return () => {
      setEmail('');
    };

  },[userEmail]);

  React.useEffect(() => {
    if (cameFrom === 'signup') {
      setCurrentPage('otp');
    } else {
      setCurrentPage('signup');
    }
    return () => {
      setCurrentPage('');
    };
  },[cameFrom]);

  

  const renderComponent = () => {
    switch (currentPage) {
      case "login":
        return (
          <LoginModal
            setCurrentPage={setCurrentPage}
            handleClose={handleClose}
            setProgress={setProgress}
            setSnackbarData={setSnackbarData}
            setOpenSnackbar={setOpenSnackbar}
          />
        );
      case "otp":
        return (
          <AccountVerification
            setCurrentPage={setCurrentPage}
            setProgress={setProgress}
            handleClose={handleClose}
            setSnackbarData={setSnackbarData}
            setOpenSnackbar={setOpenSnackbar}
            email={email}
            cameFrom={cameFrom}
          />
        );
      case "signup":
        return (
          <SignupModal
            businessType={businessType}
            setProgress={setProgress}
            setBusinessType={setBusinessType}
            setCurrentPage={setCurrentPage}
            handleClose={handleClose}
            setSnackbarData={setSnackbarData}
            setOpenSnackbar={setOpenSnackbar}
            setEmail={setEmail}
          />
        );
      default:
        return null; // Explicitly return null
    }
  };
  
  return (
    <div>
      <Modal
        open={open}
        BackdropProps={{ onClick: (e) => e.stopPropagation() }}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        slots={{ backdrop: StyledBackdrop }}
        sx={{ padding: "0" }}
      >
        <ModalContent sx={style}>{renderComponent()}</ModalContent>
      </Modal>
    </div>
  );
}

const Backdrop = React.forwardRef((props, ref) => {
  const { open, className, ...other } = props;
  return (
    <div
      className={clsx({ "base-Backdrop-open": open }, className)}
      ref={ref}
      {...other}
    />
  );
});

Backdrop.propTypes = {
  className: PropTypes.string.isRequired,
  open: PropTypes.bool
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025"
};

const Modal = styled(BaseModal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgba(11, 21, 36, 0.77);
  -webkit-tap-highlight-color: transparent;
`;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  padding: "2rem"
};

const ModalContent = styled("div")(
  ({ theme }) => css`
    font-family: "IBM Plex Sans", sans-serif;
    font-weight: 500;
    text-align: start;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: hidden;
    background-color: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border-radius: 8px;
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    box-shadow: 0 4px 12px
      ${theme.palette.mode === "dark" ? "rgb(0 0 0 / 0.5)" : "rgb(0 0 0 / 0.2)"};
    color: ${theme.palette.mode === "dark" ? grey[50] : grey[900]};

    & .modal-title {
      margin: 0;
      line-height: 1.5rem;
      margin-bottom: 8px;
    }

    & .modal-description {
      margin: 0;
      line-height: 1.5rem;
      font-weight: 400;
      color: ${theme.palette.mode === "dark" ? grey[400] : grey[800]};
      margin-bottom: 4px;
    }
  `
);
